import React from 'react'
import { CAREER_BIRU_OLD_ICON } from "assets/images"

const MemoizedImageBIRUOLD = () => {
  return (
    <img src={CAREER_BIRU_OLD_ICON} alt='' className='game-token-biru' loading="lazy" />
  )
}
export default React.memo(MemoizedImageBIRUOLD) 
